<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="handleCancel">
    <div class="gm-panel gm-panel--raised modal-content" role="dialog" aria-modal="true" :aria-label="title">
      <h3 v-if="title" class="gm-title">{{ title }}</h3>
      <p class="modal-message">{{ message }}</p>
      <div class="modal-actions">
        <button
          v-if="mode === 'confirm'"
          class="gm-btn gm-btn--ghost"
          @click="handleCancel"
        >
          {{ cancelLabel }}
        </button>
        <button
          class="gm-btn"
          :class="mode === 'confirm' ? 'gm-btn--danger' : 'gm-btn--primary'"
          @click="handleConfirm"
        >
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'confirm',
      validator: (value) => ['confirm', 'alert'].includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    confirmLabel: {
      type: String,
      default: 'OK'
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    }
  },
  emits: ['confirm', 'cancel'],
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      if (this.mode === 'alert') {
        this.$emit('confirm');
        return;
      }
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  text-align: center;
  width: 90%;
  max-width: 24rem;
}

.modal-message {
  margin: var(--gm-gap-sm) 0 0;
  color: var(--gm-text-muted);
  font-size: 0.8rem;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: var(--gm-gap-sm);
  margin-top: var(--gm-gap);
}
</style>
